import React from 'react';
export function HeroSection() {
  return <section className="bg-[#f9fafb] py-12 lg:py-20 border-b border-gray-200" data-id="element-104">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-105">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-106">
          GNLD Neolife Vitamins, Supplements and Products are simply the{' '}
          <span className="text-[#0e7be1]" data-id="element-107">
            finest, safest and most effective
          </span>{' '}
          products in the world!
        </h1>

        <div className="w-16 h-0.5 bg-[#9fd23d] mx-auto mb-6" data-id="element-108"></div>

        <p className="text-base lg:text-lg text-gray-600 leading-relaxed" data-id="element-109">
          Since 1958, Neolife has been helping millions of people fix their
          health issues! Stop wasting your money on vitamins that don't work!
          Use Neolife and{' '}
          <span className="text-[#0e7be1] font-semibold" data-id="element-110">
            See results in just days!
          </span>
        </p>
      </div>
    </section>;
}